import { useState, useEffect } from 'react';

export const useCookieConsent = () => {
    const [hasConsent, setHasConsent] = useState(null);
    const [consentType, setConsentType] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        // Verificar si ya existe consentimiento
        const checkConsent = () => {
            try {
                const consent = localStorage.getItem('cookieConsent');
                const consentDate = localStorage.getItem('cookieConsentDate');
                

                
                if (consent) {
                    setHasConsent(true);
                    setConsentType(consent);
                } else {
                    setHasConsent(false);
                }
                setIsInitialized(true);
            } catch (error) {
                console.error('Error al verificar consentimiento:', error);
                setHasConsent(false);
                setIsInitialized(true);
            }
        };

        checkConsent();
    }, []);

    const acceptCookies = () => {
        try {
            localStorage.setItem('cookieConsent', 'accepted');
            localStorage.setItem('cookieConsentDate', new Date().toISOString());
            setHasConsent(true);
            setConsentType('accepted');
            
            // Disparar evento para que Google Analytics se cargue
            if (typeof window !== 'undefined' && window.dispatchEvent) {
                window.dispatchEvent(new CustomEvent('cookieyes_consent_update', {
                    detail: { statistics: true }
                }));
            }
        } catch (error) {
            console.error('Error al aceptar cookies:', error);
        }
    };

    const declineCookies = () => {
        try {
            localStorage.setItem('cookieConsent', 'declined');
            localStorage.setItem('cookieConsentDate', new Date().toISOString());
            setHasConsent(true);
            setConsentType('declined');
            

        } catch (error) {
            console.error('Error al rechazar cookies:', error);
        }
    };

    const clearConsent = () => {
        localStorage.removeItem('cookieConsent');
        localStorage.removeItem('cookieConsentDate');
        setHasConsent(false);
        setConsentType(null);
    };

    const getConsentDate = () => {
        return localStorage.getItem('cookieConsentDate');
    };

    return {
        hasConsent,
        consentType,
        isInitialized,
        acceptCookies,
        declineCookies,
        clearConsent,
        getConsentDate,
    };
}; 